import { Spin } from "antd";
import { useSelector } from "react-redux";

export const PlayerOnboardingLoading = ({ children }) => {
  const {
    loading: { onboarding },
  } = useSelector(({ team }) => team);

  if (!!onboarding) {
    return <Spin tip={onboarding}>{children}</Spin>;
  } else {
    return children;
  }
};
